export { default } from './Stars'
